import React, { FunctionComponent } from "react";
import { Stack } from "@fluentui/react";
import { ComponentReference } from "../../api/models/component-reference";

export interface ObjectComponentReferenceInfoProps {
  componentReference: ComponentReference;
}

export const ObjectComponentReferenceInfo: FunctionComponent<ObjectComponentReferenceInfoProps> = (
  props: ObjectComponentReferenceInfoProps
) => {
  const { componentReference } = props;
  return (
    <>
      <div style={{ marginTop: "4px" }}>Instance of:</div>
      <div>
        <Stack horizontal horizontalAlign="space-between">
          <div>
            {componentReference.objectName}
            <span className="component_item_icon">{"  "}</span>
          </div>
          <div className="component_item_row_doc_name">{componentReference.documentName}</div>
        </Stack>
      </div>
    </>
  );
};
